import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, styled, Typography } from '@mui/material';

const BreadCrumbButton = styled(Button)({ gap: 4, padding: 0, justifyContent: 'start' });
const Writing = styled(Typography)(({ theme }) => ({
  color: theme.palette.blue.light,
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
}));

export function Breadcrumb({ backTo, handleClose }: { backTo: string; handleClose: () => void }) {
  return (
    <BreadCrumbButton onClick={handleClose}>
      <ArrowBackIcon fontSize='small' />
      <Writing>Back to {backTo}</Writing>
    </BreadCrumbButton>
  );
}
